<template>
  <v-flex xs12 sm12 md12>
    <v-card>
    <v-card-title>
      Ara
      <v-spacer></v-spacer>
      <v-text-field
        v-model="searchData.SearchText"
        append-icon="search"
        :label="this.$t('Search')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table :headers="headersCardItems" :items="cardItems">
      <template slot="items" slot-scope="props">
        <tr @click="pick(props.item)">
          <td class="text-xs-left">
            {{ props.item.Code }}
          </td>
          <td class="text-xs-left">
            {{ props.item.CodeName }}
          </td>
        </tr>
      </template>
    </v-data-table>
    </v-card>
  </v-flex>
</template>

<script>
import auth from "@/api/auth";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import helpers from "@/components/app/customcomp/helpers.js"

export default {
  props:{
    isCoper:{
      type:Boolean,
    },
    copertarih:{

    }
  },
  components:{
    tarihim
  },
  data() {
    return {
      searchData: {
        UserID: 0,
        CodeID: 0,
        CompanyID: 0,
        Coper:false,
        CoperTarih:null,
        Code: null,
        SearchText: null,
        Paging: {
          PageNo: 1,
          DataCount: 100,
          OrderType: 0,
        },
      },
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      cardItems:[],
      headersCardItems: [
        {
          text: "Kod",
          value: "Code",
        },
        {
          text: "Kod Adı",
          value: "CodeName",
        },
      ],
    };
  },
  mounted(){
    //this.getListItems();
  },
  watch:{
    'searchData.SearchText':function(text){
        this.getListItems();
    },

  },
  methods: {
    pick(item){
    this.$emit('closeSearchData',item); 
    },
    getListCoperDate(val){
      this.searchData.CoperTarih = val;
      this.getListItems();
    },
    getListItems() {
      this.searchData.Coper = this.isCoper;
      if(this.isCoper == true){
        if(this.searchData.CoperTarih == null){
          this.searchData.CoperTarih = helpers.getDateNow();
        }
      this.searchData.CompanyID = this.credentials.CoperSirketNo;
      }else{
      this.searchData.CompanyID = this.credentials.MuhasebeSirketNo;
      }
      this.loadingvmodel = true;
      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeList",
          this.searchData,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.cardItems = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
};

</script>

<style>
</style>